import type { ViewHook } from 'phoenix_live_view';

type ClearFlashHook = ViewHook & {
  isDestroyed?: boolean;
  clearFlashHandler?: ((event: WindowEventMap['clearFlash']) => void) | undefined;
};

const ClearFlash = {
  mounted(this: ClearFlashHook) {
    this.isDestroyed = false;
    const rootElement = this.el;
    const clearFlashHandler = (e: WindowEventMap['clearFlash']) => {
      const { id, kind, timeout } = e.detail;

      setTimeout(() => {
        if (this.isDestroyed || kind === 'error' || rootElement.id !== id || !rootElement.isConnected) return;

        rootElement.classList.add('ease-out');
        rootElement.classList.add('transition-all');
        rootElement.classList.add('transform');
        rootElement.classList.add('duration-300');
        rootElement.classList.add('opacity-0');

        setTimeout(() => {
          if (this.isDestroyed || !rootElement.isConnected) return;
          this.pushEvent('lv:clear-flash', { key: kind });
        }, 300);
      }, timeout);
    };

    this.clearFlashHandler = clearFlashHandler;
    window.addEventListener('clearFlash', clearFlashHandler);
  },

  destroyed(this: ClearFlashHook) {
    this.isDestroyed = true;
    if (this.clearFlashHandler) {
      window.removeEventListener('clearFlash', this.clearFlashHandler);
      this.clearFlashHandler = undefined;
    }
  },
} as ViewHook;

export default {
  ClearFlash,
};
